<script>
export default {
  name: 'TransitionExpand',
  functional: true,
  render(createElement, context) {
    const data = {
      props: {
        name: 'expand',
      },
      on: {
        afterEnter(e) {
          e.style.height = 'auto';
        },
        enter(e) {
          const width = getComputedStyle(e).width;

          e.style.width = width;
          e.style.position = 'absolute';
          e.style.visibility = 'hidden';
          e.style.height = 'auto';

          const height = getComputedStyle(e).height;

          e.style.width = null;
          e.style.position = null;
          e.style.visibility = null;
          e.style.height = 0;

          setTimeout(() => {
            e.style.height = height;
          });
        },
        leave(e) {
          const height = getComputedStyle(e).height;

          e.style.height = height;

          setTimeout(() => {
            e.style.height = 0;
          });
        },
      },
    };
    return createElement('transition', data, context.children);
  },
};
</script>
